module.exports = __webpack_public_path__ + "img/Weapon_200.5d12bf88.png";